import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { ZeroToEmptyPipe } from "./pipes/zero-to-empty.pipe";
import { ConfirmModalComponent } from "./confirm-modal/confirm.modal";
import { GridModule } from "./grid";
import { GridToolsModule } from "./grid-tools/grid-tools.module";
import { SearchAutocompleteModule } from "./search-autocomplete/search-autocomplete.module";
import { DateFormatPipe } from "./pipes/date-format.pipe";
import { EnumTranslationPipe } from "./pipes/enum-translation.pipe";
import { FormControlValidClassPipe } from "./pipes/form-control-valid-class.pipe";
import { ValidationErrorsModule } from "./validation/validation-errors.module";
import { PasswordInputComponent } from "./password-input/password-input.component";
import { TelenetIconModule } from "./telenet-icons";
import { CustomMessageComponent } from "./messages/custom-message.component";
import { TelenetCheckboxComponent } from "./checkbox/telenet-checkbox.component";
import { TelenetRadioButtonComponent } from "./radio-button/telenet-radio-button.component";
import { TelenetStepperComponent } from "./stepper/telenet-stepper.component";
import { DuplicateEmailValidatorDirective } from "./directives/duplicate-email-validator.directive";
import { PeppolIdValidatorDirective } from "./directives/peppol-id-validator.directive";
import { PasswordVisibilityToggleComponent } from "./password-visibility-toggle/password-visibility-toggle.component";
import { SafeSanitizerPipe } from "./pipes/safe-sanitizer.pipe";
import { CheckedValueDirective } from "./checkbox/directives/checked-value.directive";
import { DynamicValidationsHeightDirective } from "./directives/dynamic-validations-height.directive";
import { ShowIfFeatureFlagEnabledDirective } from "./directives/show-if-feature-flag-enabled.directive";
import { ShowIfFeatureFlagDisabledDirective } from "./directives/show-if-feature-flag-disabled.directive";

@NgModule({
   imports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      RouterModule,
      TranslateModule,
      GridModule,
      GridToolsModule,
      SearchAutocompleteModule,
      ValidationErrorsModule,
      TelenetIconModule,
      ZeroToEmptyPipe,
      ConfirmModalComponent,
      DateFormatPipe,
      EnumTranslationPipe,
      FormControlValidClassPipe,
      PasswordInputComponent,
      CustomMessageComponent,
      TelenetCheckboxComponent,
      CheckedValueDirective,
      TelenetRadioButtonComponent,
      TelenetStepperComponent,
      DuplicateEmailValidatorDirective,
      PeppolIdValidatorDirective,
      PasswordVisibilityToggleComponent,
      SafeSanitizerPipe,
      DynamicValidationsHeightDirective,
      ShowIfFeatureFlagEnabledDirective,
      ShowIfFeatureFlagDisabledDirective
   ],
   exports: [
      CommonModule,
      FormsModule,
      ReactiveFormsModule,
      RouterModule,
      TranslateModule,
      GridModule,
      GridToolsModule,
      SearchAutocompleteModule,
      ValidationErrorsModule,
      ZeroToEmptyPipe,
      ConfirmModalComponent,
      DateFormatPipe,
      FormControlValidClassPipe,
      EnumTranslationPipe,
      PasswordInputComponent,
      CustomMessageComponent,
      TelenetCheckboxComponent,
      CheckedValueDirective,
      TelenetRadioButtonComponent,
      TelenetStepperComponent,
      DuplicateEmailValidatorDirective,
      PeppolIdValidatorDirective,
      PasswordVisibilityToggleComponent,
      SafeSanitizerPipe,
      DynamicValidationsHeightDirective,
      ShowIfFeatureFlagEnabledDirective,
      ShowIfFeatureFlagDisabledDirective
   ],
   providers: []
})
export class SharedModule {
   static forRoot(): ModuleWithProviders<SharedModule> {
      return {
         ngModule: SharedModule,
         providers: []
      };
   }
}
